(function () {
  function initImageGallerySliders() {
    const sliderSections = document.querySelectorAll('.image-gallery--slider');
    sliderSections.forEach(function (box) {
      if (box.classList.contains('image-gallery__slider_started')) {
        return;
      }
      const sectionId = box.dataset.id || (box.closest('section') && box.closest('section').id);
      if (!sectionId) return;
      const sliderEl = box.querySelector('.image-gallery__slider');
      if (!sliderEl || !sliderEl.classList.contains('swiper')) return;

      box.classList.add('image-gallery__slider_started');

      const autoplay = String(box.dataset.autoplay || '') === 'true';
      const stopAutoplay = String(box.dataset.stopAutoplay || '') !== 'false';
      const speed = parseFloat(box.dataset.speed) || 1.1;
      const delayMs = (parseFloat(box.dataset.delay) || 3) * 1000;
      const effect = box.dataset.effect || 'slide';
      const showArrows = box.dataset.showArrows !== 'false';
      const showBullets = box.dataset.showBullets !== 'false';
      const slidesMobile = Math.max(1, parseInt(box.dataset.slidesMobile, 10) || 1);
      const slidesTablet = Math.max(1, parseInt(box.dataset.slidesTablet, 10) || 2);
      const slidesDesktop = Math.max(1, parseInt(box.dataset.slidesDesktop, 10) || 3);
      const spaceBetween = Math.max(0, parseInt(box.dataset.spaceBetween, 10) || 16);

      var autoplayParam = {};
      if (autoplay && delayMs > 0) {
        autoplayParam = {
          autoplay: {
            delay: delayMs,
            pauseOnMouseEnter: stopAutoplay,
            disableOnInteraction: false
          }
        };
      }

      var navParam = {};
      if (showArrows) {
        navParam = {
          navigation: {
            nextEl: '#' + sectionId + ' .swiper-button-next',
            prevEl: '#' + sectionId + ' .swiper-button-prev'
          }
        };
      }

      var paginationParam = {};
      if (showBullets) {
        paginationParam = {
          pagination: {
            el: '#' + sectionId + ' .swiper-pagination',
            clickable: true
          }
        };
      }

      var swiperParams = {
        effect: effect,
        speed: speed * 1000,
        loop: true,
        autoHeight: false,
        keyboard: true,
        slidesPerView: slidesMobile,
        spaceBetween: spaceBetween,
        breakpoints: {
          750: { slidesPerView: slidesTablet },
          990: { slidesPerView: slidesDesktop }
        },
        creativeEffect: {
          prev: { shadow: true, translate: [0, 0, -400] },
          next: { translate: ['100%', 0, 0] }
        },
        coverflowEffect: {
          rotate: 50,
          stretch: 0,
          depth: 100,
          modifier: 1,
          slideShadows: true
        },
        flipEffect: { slideShadows: true }
      };

      Object.assign(swiperParams, autoplayParam, navParam, paginationParam);

      if (typeof Swiper !== 'undefined') {
        const swiper = new Swiper('#' + sectionId + ' .image-gallery__slider', swiperParams);
        if (autoplay && delayMs > 0 && swiper.autoplay) {
          swiper.autoplay.start();
        }
      }
    });
  }

  document.addEventListener('DOMContentLoaded', initImageGallerySliders);
  document.addEventListener('shopify:section:load', initImageGallerySliders);
})();
